module.exports = __webpack_public_path__ + "static/media/ZT65.8315ba34.pdf";